const messages = {
  en: {
    translations: {
      aiOperational: {
        blockedReply: "I am still here to help with your request.",
        blockedAudit: "AI action not executed under the service rules",
        summaryMissingTime: "Enter the delays to review the closure sequence.",
        summaryNoInactivity: "Closure for no response disabled.",
        summaryNoFollowUp: "Follow-up disabled.",
        summaryFollowUp: "Follow-up after {{minutes}} minute(s) without a reply.",
        summaryCommunication: "Message on closure: {{mode}}.",
        summaryResolution: "Closure on completion: {{mode}}.",
        summaryNoTransfer: "Transfers disabled.",
        summaryTransfer: "Transfers allowed to {{count}} destination(s).",
        summaryTitle: "Review before saving",
        followUpInstructionHelp: "Describe how to resume the conversation. This is the only follow-up editor in the current mode.",
        minutesHelp: "Enter a whole number greater than zero.",
        inactivityMinutes: "Wait before closure (minutes)",
        followUpMinutes: "Wait before follow-up (minutes)",
        resolutionHelp: "Choose when the agent may recognize completion. A technical failure or pending request does not mean the conversation is complete.",
        confirmationHelp_not_required: "The agent may decide to transfer without asking for confirmation, within the configured destinations and rules.",
        confirmationHelp_always: "Even if the contact requests a transfer directly, the agent must ask for confirmation.",
        confirmationHelp_direct_request_or_acceptance: "A direct request permits transfer. If the agent suggests transferring, it must wait for acceptance.",
        noDestinations: "No destinations found.",
        aiNotAllowed: "This department does not allow AI agents.",
        agentNotReady: "The destination agent is not active and ready to receive transfers yet.",
        unavailableDestination: "Destination unavailable in the current configuration.",
        selfDestination: "The agent cannot transfer to itself.",
        savedUnavailable: "Saved destination unavailable",
        missingDestinations: "{{count}} saved destination(s) are absent from the current list. They were preserved; review the configuration before saving.",
        selectGroup: "Select this department",
        clearEligible: "Deselect available",
        selectAll: "Select all available",
        selectedCount: "Selected destinations: {{count}}",
        searchDestinations: "Search department or person",
        followUpTitle: "Follow-up and closure",
        transferTitle: "Transfers",
        unsupportedPolicy: "The saved configuration uses an unrecognized format. Your data was preserved. Request a review before changing the mode.",
        legacyMode: "This agent uses the previous mode. Its proactive messaging and closure options remain available below. Enabling the new rules changes the service mode when saved.",
        currentMode: "These options control transfers, follow-up and closure. Previous-mode values remain saved.",
        loading: "Loading availability and destinations...",
        transferInstruction: "Short instruction on when to transfer",
        followUpPreview: "Reply sent → wait {{followUp}} min → send follow-up → wait another {{close}} min → close if there is no reply and the conversation is eligible for closure.",
        directPreview: "Reply sent → wait {{close}} min → close if there is no reply and the conversation is eligible for closure.",
  "title": "Service rules",
  "help": "Configure what the agent can do. Set permissions and timing here; use instructions to guide the conversation.",
  "ready": "Rules available in this environment.",
  "pending": "These rules are not enabled in this environment yet. You can prepare the configuration; it will take effect after activation.",
  "catalogFailed": "Destinations could not be loaded. Reopen the form before configuring transfers.",
  "enable": "Use transfer and closure rules",
  "transfer": "Allow transfers",
  "destinationsHelp": "Choose departments or people to receive transfers. A person may appear in multiple departments. This selection does not change the departments where this agent works.",
  "defaultDestination": "Destination for requests without a department",
  "askDestination": "Ask for the destination",
  "confirmation": "When to ask for transfer confirmation",
  "directOrAccept": "When suggesting a transfer",
  "always": "Always ask for confirmation",
  "notRequired": "Allow transfers without confirmation",
  "continuity": "Transfers to another AI agent carry the request and related documents with the conversation.",
  "resolution": "When to close a completed conversation",
  "off": "Disabled",
  "activeOnly": "When the contact responds to follow-up",
  "clearResolution": "When the agent identifies completion",
  "followUp": "Send follow-up when the contact stops responding",
  "inactivity": "Close if the contact continues without responding",
  "minutes": "Minutes — required and greater than zero",
  "followUpAnchor": "Under V2, an AI reply or confirmed API send starts the first delay. The closure delay follows the follow-up. If the AI chooses silence without pending work or the channel blocks follow-up, inactivity proceeds without another follow-up.",
  "directAnchor": "Without follow-up, the closure delay starts after a confirmed send. Under V2, AI silence also starts this delay when no offer or team work is pending. Closure outside the WhatsApp Official window is silent.",
  "cancelHelp": "A new reply, human takeover, transfer or reopening cancels the previous timer. Failed sends do not start a timer. Changing these rules also cancels previous timers.",
  "followUpInstruction": "Short follow-up instruction",
  "communication": "Communication on closure",
  "silent": "No additional message",
  "farewell": "One configured farewell",
  "farewellText": "Farewell text",
  "validation": "Validate in separate test conversations: direct request, accepted and declined offers, ambiguous response, clear resolution and a pending request. Check queue, assignee, status and history; the agent wording does not prove execution."
},
      myProfile: {
        title: "My profile", description: "Update your personal details and preferences. Permissions, queues, and schedules are managed by the organization.", changePhoto: "Change photo", photoHelp: "PNG, JPG, or WebP.", name: "Name", email: "Email", password: "New password", passwordHelp: "Your current password is not displayed. Leave blank to keep it or enter a new password.", language: "Language", ticketOrder: "Conversation order", oldestFirst: "Oldest first", newestFirst: "Newest first", save: "Save changes", saving: "Saving...", success: "Profile updated successfully."
      },
      organization: {
        title: "Organization", description: "Tenant identity, institutional details, and general preferences.", guidance: "This information belongs to your company and is isolated from other tenants. Only administrators can change it.", logo: "Light logo", logoDark: "Dark logo", logoHelp: "PNG, JPG, or WebP; up to 2 MB.", name: "Company name", businessName: "Legal name", document: "Tax ID or document", phone: "Phone", email: "Institutional email", website: "Website", address: "Address", timezone: "Time zone", defaultLanguage: "Default language", primaryColor: "Primary color", tenantId: "Tenant code", save: "Save organization", saving: "Saving...", success: "Organization details updated."
      },
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          companyName: "Company",
          name: "Name",
          email: "Email",
          password: "Password",
          language: "Language",
          languageOptions: {
            pt: "Portuguese (Brazil)",
            en: "English",
            es: "Spanish"
          }
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Conversations today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        },
        indicators: {
          title: "Indicators",
          filters: {
            period: "Period",
            start: "Start",
            end: "End",
            queue: "Queue",
            connection: "Connection",
            allQueues: "All my queues",
            allConnections: "All connections",
            nowNote: "Now shows the current situation. Use Queue and Connection to narrow this snapshot.",
            periodNote: "Period, Queue and Connection filter the indicators in this tab.",
          },
          periods: {
            today: "Today",
            yesterday: "Yesterday",
            thisWeek: "This week",
            lastWeek: "Last week",
            thisMonth: "This month",
            lastMonth: "Last month",
            custom: "Custom period",
          },
          tabs: {
            now: "Now",
            period: "Period",
            agents: "Agents",
            queues: "Queues",
            connections: "Connections",
            lists: "Lists",
          },
          periodMetrics: {
            started: "Started",
            reopened: "Reopened",
            closed: "Closed",
            reopenRate: "Reopen rate",
            firstResponse: "Average first response",
            resolution: "Average resolution",
            inbound: "Received messages",
            outbound: "Sent messages",
            closedByHour: "Closed by hour",
          },
          global: {
            health: "Operation Temperature",
            waitingForService: "Waiting for Service",
            inService: "In Service",
            unanswered: "Service Without Reply",
            averageWait: "Average Wait Time",
            longestWait: "Longest Wait",
            busiestAgent: "Most Active Agent in Service",
            busiestArea: "Queue With Most Waiting Conversations",
            healthDescription: "Overall service health right now, independent from the filters below.",
            scale: {
              excellent: "Excellent",
              good: "Good",
              warning: "Warning",
              critical: "Critical",
              emergency: "Emergency",
            },
          },
          help: {
            tooltip: "Indicator help",
            compositionTitle: "What counts",
            improveTitle: "How to improve",
            close: "Close",
            backlog: {
              title: "Active backlog",
              description: "Open + pending tickets within the queues you can access.",
              insight: "Reduce backlog with quick triage, queue distribution, and automations for recurring questions.",
            },
            waiting: {
              title: "% waiting",
              description: "Percentage of pending tickets over open + pending. The higher it is, the larger the triage bottleneck.",
              insight: "Set alerts when it exceeds the limit and pull conversations to avoid queue aging.",
            },
            unread: {
              title: "Total unread",
              description: "Conversations with unread messages in your scope.",
              insight: "Prioritize older unread conversations and use alerts for time without reading.",
            },
            ratio: {
              title: "Service vs queue ratio",
              description: "Compares open tickets with pending tickets. Higher than 1 indicates the team is pulling from the queue.",
              insight: "Keep it above 1 during peak hours with staffing adjustments and routing.",
            },
            flow: {
              title: "Hourly flow",
              description: "Hourly distribution based on the period volume within the applied filter.",
              insight: "Use peak hours to reinforce the team and preventive automations.",
            },
            age: {
              title: "Ticket age",
              description: "Time ranges without progress for open and pending tickets.",
              insight: "Tickets above 60 minutes should enter a priority queue.",
            },
            queue: {
              title: "Tickets by queue",
              description: "Top queues in the filtered period.",
              insight: "Rebalance the team when one queue concentrates too much volume.",
            },
            agentAvg: {
              title: "Average time by agent",
              description: "Average time between opening and last update of closed tickets by agent in the filtered period.",
              insight: "Compare with served volume to identify bottlenecks and support the team with the highest average queue.",
            },
            channel: {
              title: "Tickets by connection",
              description: "Distribution by connection in the filtered period.",
              insight: "Route automations to connections with higher inbound volume.",
            },
            group: {
              title: "Groups vs Individuals",
              description: "Compares group tickets with individual conversations.",
              insight: "If groups grow, apply rules and fixed owners to reduce noise.",
            },
          },
          sections: {
            flow: "Hourly flow",
            closed: "Closed: {{count}}",
            ageRanges: "Age ranges",
            ticketsByQueue: "Tickets by queue (Top 10)",
            ticketsByConnection: "Tickets by connection",
            groupsVsIndividuals: "Groups vs Individuals",
            agentAverage: "Average service time by agent (Top 10)",
            operationalInsights: "Operational insights",
            currentSample: "Current filter sample: {{count}} tickets",
            agents: "Agent performance",
            queues: "Queue performance",
            connections: "Connection performance",
          },
          empty: {
            movement: "No movement in the period. Expand the period or select another connection.",
            age: "No active tickets in the period to calculate age ranges.",
            queue: "No queue volume in the selected period.",
            connection: "No connection volume in the selected period.",
            group: "Not enough tickets to compare groups and individuals.",
            agentAverage: "No closed tickets with an agent in the selected period.",
            noData: "No data for the selected filter.",
          },
          rank: {
            active: "active",
            closed: "closed",
            sent: "sent",
            waiting: "waiting",
            inService: "in service",
            started: "started",
            inbound: "received",
          },
          table: {
            agent: "Agent",
            agentType: "Agent type",
            queue: "Queue",
            connection: "Connection",
            channel: "Channel",
            active: "Open",
            waiting: "Waiting",
            inService: "In service",
            started: "Started",
            closed: "Closed",
            closedPercentage: "Closed percentage",
            sent: "Messages sent",
            inbound: "Received",
            avgWait: "Avg. wait",
            avgResolution: "Resolution time",
          },
          attendantType: {
            human: "Human",
            aiAgent: "AI agent",
            unassigned: "No agent",
          },
          actionLists: {
            waitingLongest: "Longest waiting",
            unanswered: "No agent reply",
            slaRisk: "SLA risk",
            reopened: "Reopened in period",
          },
          fallback: {
            connection: "Connection {{id}}",
            noQueue: "No queue",
            noConnection: "No connection",
            noAgent: "No agent",
            noDefinedQueue: "No queue defined",
            groups: "Groups",
            individuals: "Individuals",
          },
          chart: {
            entries: "Entries",
          },
          insights: {
            noBacklog: "No active backlog in the current scope. Use the moment to review macros and triage rules for the next peaks.",
            highWaiting: "Queue under pressure: {{pendingCount}} pending ({{waitingPercent}}%). Reallocate agents to queues with higher volume immediately.",
            mediumWaiting: "Waiting attention: {{waitingPercent}}% of tickets are pending. Set a short task force to reduce pending work below 25%.",
            oldestPending: "There is a pending ticket waiting for {{minutes}} min. Prioritize the oldest ones to protect SLA.",
            unread: "There are {{count}} unread conversations. Sort by oldest and clear them in batches of 10.",
            topQueue: "Queue {{name}} concentrates {{share}}% of the volume. Evaluate team redistribution or dedicated automation.",
            topConnection: "Connection {{name}} represents {{share}}% of demand. It is worth reviewing capacity and templates for this connection.",
            stable: "Operation is stable in the current filter. Keep hourly monitoring and fine-tune by queue when peaks appear.",
          },
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
          restarting: "Restarting the connection. Wait a few moments.",
          paused: "Connection paused. Use Restart connection to resume without scanning QR Code.",
          disconnected: "Connection disconnected. To resume, generate and scan a new QR Code.",
          openTicketsHistorySynced:
            "History synced across {{tickets}} open conversations. {{messages}} new messages imported. Failures: {{failures}}.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          restart: "Restart connection",
          connecting: "Connectiing",
          sessionActions: "Session actions",
        },
        sessionMenu: {
          viewQr: "View current QR Code",
          viewQrHelp: "Shows the QR Code when the connection is waiting to be scanned.",
          restart: "Restart without new QR",
          restartHelp: "Closes and opens the local session while keeping the phone authenticated.",
          pause: "Pause connection",
          pauseHelp: "Stops the local session without logging out of WhatsApp on the phone.",
          syncOpenTicketsHistory: "Sync open conversations",
          syncOpenTicketsHistoryHelp:
            "Fetches recent WhatsApp messages for open tickets on this connection.",
          newQr: "Request new QR Code",
          newQrHelp: "Clears the local session and generates a new QR Code to scan.",
          disconnect: "Disconnect from phone",
          disconnectHelp: "Logs out of WhatsApp Web. To resume, a new QR Code scan is required.",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try restarting the connection. Request a new QR Code only if the session does not recover.",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open. Use Restart connection before requesting a new QR Code.",
          },
        },
        table: {
          id: "ID",
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      connectionSetup: {
        back: "Back",
        cancel: "Cancel",
        close: "Close",
        save: "Save",
        saving: "Saving...",
        retry: "Retest",
        connectWithMeta: "Connect with Meta",
        connecting: "Connecting...",
        waitingMeta: "Waiting for Meta...",
        configureManually: "Configure manually",
        officialApi: "Official API",
        qrCode: "QR Code",
        noDefaultQueue: "No default queue",
        selectQueue: "Select a queue",
        defaultConnection: "Mark as default",
        makeDefaultConnection: "Make default connection",
        connectionName: "Connection name",
        queueForNewContacts: "Queue for new contacts",
        outboundQueues: "Queues allowed for outbound conversations",
        outboundQueuesHelp: "Select which queues may use this connection when manually starting a conversation.",
        userForNewContacts: "User for new contacts",
        userForNewContactsHelp: "Optional. Select a human or AI agent to automatically take new conversations from this connection.",
        selectUser: "Select a user",
        webhookUrl: "Webhook URL",
        webchat: {
          customizationSaveHelp: "Adjust the appearance and click Save customization to apply it to this connection. The published snippet stays the same and does not expire; replace it only if the connection is recreated or its public key is rotated for security.",
          saveCustomization: "Save customization",
          customizationSaved: "Webchat customization saved successfully.",
          prechatTitle: "Fields before chat",
          prechatHelp: "Choose which visitor details should be requested before the conversation. If all options are off, the chat opens directly in the conversation.",
          askName: "Ask name",
          askEmail: "Ask email",
          askWhatsapp: "Ask WhatsApp",
          showFrame: "Show frame in Embed Line",
          showFrameHelp: "Turn this off to blend the chat into the website layout. Before the first message, only the compact composer is shown; after sending, the conversation expands automatically.",
        },
        facebook: {
          titleAdd: "New Facebook Messenger Connection",
          titleEdit: "Edit Facebook Messenger",
          autoDescription: "Sign in with the Meta account that manages the Page, authorize the Flowch app, and choose which Page will receive messages in Flowch Talk. The Page token, webhook, and subscription are handled automatically by the backend.",
          manualDescription: "Use this only when support or technical implementation needs to enter the Page ID, Page Access Token, and Verify Token directly.",
          manualIntro: "Use this connection to receive messages from the Facebook Page through Messenger. The contact must start the conversation from the Page; after that, Flowch Talk can reply within the window allowed by Meta.",
          pageIdHelp: "ID of the Facebook Page that will receive the messages.",
          pageAccessTokenEdit: "Page Access Token (optional to keep the current one)",
          pageAccessTokenHelp: "Page token with permission to send messages through Messenger.",
          verifyTokenHelp: "Create a secure keyword and use exactly the same value in the Meta webhook configuration.",
          queueHelp: "Messages received by the Page enter this queue.",
          webhookTitle: "Configure webhook in Meta",
          webhookInstructions: "1. Save this connection. 2. In the Meta app, configure the Messenger webhook using the URL below. 3. Enter the same Verify Token registered here. 4. Subscribe to the Page messaging events and send a test message through Messenger.",
          autoIntro: "Enter an internal identifier and the default queue. Then click Connect with Meta. The customer must sign in with an account that manages the Page, accept the requested permissions, and select the Page to connect. When finished, Flowch Talk securely saves the credentials, subscribes the webhook, and runs the diagnosis automatically.",
          nameAutoHelp: "If left blank, Flowch creates a name automatically.",
          choosePageTitle: "Choose the Facebook Page",
          choosePageHelp: "The connection will be created with the selected Page. After that, it remains available for editing name, queue, default status, and credentials in manual mode when support needs it.",
          pageLabel: "Page",
          complete: "Complete connection",
          subscribeWebhook: "Subscribe Page webhook",
          validationRequired: "Enter name, Page ID, Verify Token, and Page Token.",
          updated: "Facebook Messenger connection updated successfully.",
          created: "Facebook Messenger connection created successfully.",
          metaStartFailed: "Could not start the Meta flow.",
          popupBlocked: "Your browser blocked the Meta popup. Allow popups and try again.",
          finishLogin: "Finish the Meta login in the opened window to list your Pages.",
          selectPage: "Select a Facebook Page to continue.",
          pageNotFound: "Selected Page not found.",
          diagnosisPending: "Connection created, but the diagnosis found pending items.",
          loginCompleted: "Meta login completed. Select the Page to connect.",
          webhookSubscribed: "Webhook subscription requested successfully.",
        },
        whatsappOfficial: {
          titleAdd: "New Official WhatsApp Connection (API)",
          titleEdit: "Edit Official WhatsApp (API)",
          autoDescription: "Sign in with the Meta account that manages the business, select the WABA and WhatsApp number. Flowch Talk saves the credentials, configures the webhook, and runs the diagnosis automatically.",
          manualDescription: "Use this when support or technical implementation needs to enter Official API fields manually or connect through QR Code.",
          officialApiDescription: "Use your Meta account data, such as WABA ID, Phone Number ID, token, and verify token.",
          qrCodeDescription: "Manually connect an account through WhatsApp Web pairing when the Official API is not the best option.",
          manualIntro: "Enter the WABA ID, Phone Number ID, Access Token, and Verify Token from the WhatsApp Business Platform. Then save and test the connection to validate token, number, WABA, and webhook.",
          metaIntro: "Click Connect with Meta, authorize the requested permissions, and choose the WhatsApp business/number. When finished, Flowch Talk fetches the WABA ID, Phone Number ID, and token, subscribes the Meta webhook, and shows the final diagnosis.",
          cloudApiModeTitle: "New number / API",
          cloudApiModeDescription: "Connect a new number or one already prepared exclusively for Meta's Official API.",
          coexistenceModeTitle: "Keep using WhatsApp Business",
          coexistenceModeDescription: "Keep the same number in the WhatsApp Business app while also serving customers in Flowch Talk.",
          coexistenceIntro: "Click Connect with Meta and choose the number already active in the WhatsApp Business app. Flowch verifies coexistence, imports authorized history, and mirrors phone-sent messages without triggering AI.",
          coexistenceEligibilityHelp: "Meta requirements: an up-to-date WhatsApp Business app, an eligible number, and coexistence enabled for the Flowch app. This option never disconnects the phone automatically.",
          coexistenceConfigurationPending: "Unavailable in this environment until the Meta app configuration is completed.",
          coexistenceUnavailable: "Coexistence is not configured in this environment yet. Use New number / API or ask support to enable it.",
          coexistenceBadge: "Coexistence",
          metaApplicationLabel: "Meta app",
          metaApplicationHelp: "Use the Flowch app configured for this environment or select the company's own app. Webhook signatures and Embedded Signup will use only the credentials selected here.",
          metaApplicationFlowchDefault: "Default Flowch app for this environment",
          metaApplicationOwnerFlowch: "Flowch",
          metaApplicationOwnerCompany: "Company-owned app",
          metaApplicationAdd: "Add company-owned app",
          metaApplicationEdit: "Edit app",
          metaApplicationAddTitle: "Add the company's Meta app",
          metaApplicationEditTitle: "Edit the company's Meta app",
          metaApplicationInstructions: "In Meta for Developers, copy App ID and App Secret. Define a Verify Token for the webhook. Config IDs are required only for Embedded Signup/coexistence. After saving, use the displayed URL and subscribe to messages. Secrets are encrypted and not returned.",
          metaApplicationName: "Internal app name",
          metaApplicationSecretHelp: "The App Secret is encrypted at rest and will never be displayed again.",
          metaApplicationVerifyTokenEditHelp: "Leave blank to keep the current Verify Token. To replace it, enter at least 16 characters and update the same value in Meta’s webhook; verification may fail until both sides are updated.",
          metaApplicationVerifyTokenRequired: "Set a Verify Token with at least 16 characters for a new app. When editing, leave blank to preserve the current value.",
          metaApplicationConfigHelp: "Required only for Connect with Meta (Embedded Signup). Manual setup does not require a Config ID.",
          metaApplicationWebhookChecklist: "In Meta, use this callback URL and the Verify Token defined for the app; subscribe to messages. Then check diagnostics. Saved settings do not prove messages are sent or received.",
          setupQueueMissing: "No queues available. Close this form, create a queue under Queues, then return to Connections. A destination queue is required.",
          manualVerifyTokenHelp: "Enter the Verify Token defined for the selected app. For the environment default, use its configured token. Do not use the Access Token in this field.",
          manualSaveEffects: "Saving may configure the webhook and subscribe the app to the WhatsApp account using the selected credentials. Save and test creates the connection before querying Meta. Neither action sends a test message.",
          testConnection: "Test connection",
          saveAndTestConnection: "Save and test connection",
          metaApplicationVerifyTokenHelp: "Set a Verify Token with at least 16 characters and keep it securely to enter in Meta’s Verify token field. It is not the Access Token. The stored value will not be shown again.",
          metaApplicationSave: "Save app",
          metaApplicationDelete: "Delete app",
          metaApplicationDeleteConfirm: "Delete this Meta app? Deletion is only allowed when no connection is linked to it.",
          metaApplicationWebhookHelp: "URL to register in the Meta webhook",
          metaApplicationRequired: "Enter name, App ID, and App Secret.",
          metaApplicationSaved: "Meta app saved securely.",
          metaApplicationRemoved: "Meta app removed.",
          selectQueueRequired: "Select the queue for new contacts.",
          secretKeepCurrent: "Leave blank to keep the securely stored credential.",
          popupHelp: "If the popup is blocked, allow popups for this domain and try again. A connection created through Meta remains manually editable for future adjustments.",
          manualRequired: "Fill in all manual configuration fields.",
          saved: "Official connection saved successfully.",
          tested: "Connection tested successfully.",
          templatesSynced: "Templates synchronized successfully.",
          friendlyNamesSaved: "Friendly names saved.",
          templateFieldsRequired: "Enter the technical name and main template text.",
          templateSubmitted: "Template sent to Meta for approval.",
          metaCancelled: "Meta flow was cancelled before completion.",
          metaAuthFailed: "Meta authentication failed.",
          metaReturnFailed: "Could not complete the Meta return.",
          metaStartFailed: "Could not start the Meta flow.",
          finishMetaSetup: "Finish the Meta login in the opened window to complete the connection automatically.",
          created: "Official connection created successfully.",
          diagnosisPending: "Connection created, but the diagnosis found pending items.",
          diagnosisConnectionName: "Official WhatsApp",
          templates: {
            createTitle: "Create a template in Meta",
            createHelp: "Use clearly named variables and provide one example for each. Meta will review the template, and it can only be used after approval.",
            technicalName: "Technical name (Meta)",
            technicalNameHelp: "Use lowercase letters, numbers, and underscores only.",
            friendlyName: "Friendly name (internal)",
            category: "Category",
            language: "Language",
            parameterFormat: "Variable format",
            namedFormat: "By name — recommended",
            positionalFormat: "By position — advanced",
            namedHelp: "Easier to configure and maintain. Use names such as nome and data.",
            positionalHelp: "Compatibility with older templates. Use numbered positions in sequence.",
            insertVariable: "Insert a common variable",
            body: "Main text (BODY)",
            bodyNamedHelp: "Use the buttons above or type variables with lowercase names.",
            bodyPositionalHelp: "Use numbered variables in sequence, starting at position 1.",
            exampleFor: "Example for {{variable}}",
            createAction: "Submit for Meta review",
            mixedVariablesError: "Do not mix named and positional variables in the same template.",
            namedFormatError: "In the recommended format, use named variables instead of numbers.",
            positionalFormatError: "In positional format, use sequential numbers only.",
            examplesRequired: "Provide an example for every variable before submitting to Meta.",
          },
        },
        diagnosis: {
          title: "Meta Diagnosis - {{name}}",
          retry: "Retest",
          close: "Close",
          labels: {
            pageId: "Page ID",
            verifyToken: "Verify Token",
            webhookUrl: "Webhook URL",
            secrets: "Saved credentials",
            pageAccessToken: "Page Access Token",
            pageTokenMatch: "Token x Page",
            pageWebhookSubscription: "Page subscriptions",
            recentInbound: "Message receiving",
            diagnose: "General diagnosis",
            defaultCheck: "Check",
            webhookMeta: "Meta Webhook",
          },
          webhookUnavailable: "Webhook diagnosis unavailable.",
          expectedVsMeta: "Expected: {{expected}} | Meta: {{meta}}",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          defaultUser: "User for new contacts",
          farewellMessage: "Farewell message",
          outboundQueues: "Queues allowed for outbound conversations",
          outboundQueuesHelp: "These queues may select this connection when creating a conversation manually.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          saving: "Saving...",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related conversations will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          numberHelp: "Brazil (+55) is applied automatically. You may paste the number with spaces, parentheses, or hyphens.",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        validation: {
          nameTooShort: "Enter at least 2 characters.",
          nameTooLong: "The name must have at most 50 characters.",
          nameRequired: "Enter the name.",
          numberRequired: "Enter the WhatsApp number.",
          numberInvalid: "Enter a valid phone number with area code. +55 will be added automatically.",
          emailInvalid: "Enter a valid email address.",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          saving: "Saving...",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          saving: "Saving...",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        tabs: {
          basicData: "Basic data",
          integrations: "Integrations",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
          startAttendanceMessage: "Message When Starting Attendance",
          finishAttendanceMessage: "Message When Finishing Attendance",
          allowManualAttendance: "Allow manual attendance in this queue",
          allowAiAgents: "Allow AI agents in this queue",
          allowAiAgentsHelp: "When disabled, no AI Agent user can assume conversations in this queue.",
          aiHandoffQueue: "Human handoff queue",
          aiHandoffQueueNone: "No default handoff queue",
          aiHandoffQueueHelp: "When the AI agent needs to pass the conversation to a person without naming a user or department, the conversation will move to this queue.",
        },
        integrations: {
          empty: "No integrations added.",
          integrationLabel: "Integration {{number}}",
          buttons: {
            add: "Add integration",
          },
          form: {
            type: "Integration type",
            name: "Integration name",
            webhookUrl: "Webhook URL",
            triggerEvents: "Trigger events",
            contact: "Contact",
            specificContacts: "Specific contacts",
            searchContactPlaceholder: "Type to search contacts",
            token: "Token (optional)",
            status: "Status",
          },
          types: {
            webhook: "Webhook",
            flowch: "Flowch",
          },
          flowch: {
            form: {
              endpointUrl: "Flowch integration URL",
              docUrl: "Loaded document",
              fieldMappings: "Field mappings",
              mappingLabel: "Field {{number}}",
              fieldName: "Field name",
              fieldLabel: "Help text",
              valueMode: "Value type",
              source: "Talk source",
              fixedValue: "Fixed value",
            },
            buttons: {
              loadDoc: "Load process",
              addField: "Add field",
            },
            messages: {
              endpointRequired: "Fill in the integration URL to load the process.",
              docLoaded: "Process loaded successfully. Fields are ready for mapping.",
            },
            boolean: {
              yes: "Yes",
              no: "No",
            },
            valueMode: {
              talk: "Talk source",
              fixed: "Fixed value",
            },
            sources: {
              ticketId: "Conversation ID",
              messageId: "Message ID",
              contactId: "Contact ID",
              contactNumber: "Contact number",
              contactLid: "Contact LID",
              contactIsGroup: "Contact is group",
              messageContactId: "Message author ID",
              messageContactName: "Message author name",
              messageContactNumber: "Message author number",
              participantContactId: "Group participant ID",
              participantName: "Group participant name",
              participantNumber: "Group participant number",
              participantLid: "Group participant LID",
              groupContactId: "Group ID",
              groupName: "Group name",
              groupNumber: "Group number",
              messageBody: "Message body",
              fromMe: "Sent by agent",
              mediaType: "Media type",
              ticketStatus: "Conversation status",
              userId: "User ID",
              whatsappId: "Connection ID",
              whatsappName: "Connection name",
              connectionId: "Generic connection ID",
              connectionName: "Generic connection name",
              channel: "Channel",
              provider: "Provider",
              event: "Integration event",
              queueId: "Queue ID",
              timestamp: "Dispatch timestamp",
              fixed: "Fixed value",
            },
          },
          status: {
            active: "Active",
            inactive: "Inactive",
          },
          contactScope: {
            all: "All contacts",
            specific: "Specific contact",
          },
          events: {
            messageReceived: "Message received",
            messageSent: "Message sent",
            conversationStarted: "Conversation started",
            conversationFinished: "Conversation finished",
          },
          test: {
            button: "Test integration",
            resultTitle: "Test result",
            requestData: "Request data",
            responseData: "Response data",
            messages: {
              success: "Test executed successfully.",
            },
          },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          saving: "Saving...",
          cancel: "Cancel",
        },
      },
      userModal: {
        configuration: {
  "legacyTitle": "Previous-mode options",
  "legacyHelp": "Used by agents without the new service rules. Their values remain saved when the mode changes.",
  "advancedTitle": "Advanced AI settings",
  "advancedHelp": "Provider, model and limits. Change only if you understand the impact on behavior and usage.",
  "knowledgeTitle": "Knowledge and capabilities",
  "knowledgeHelp": "Organize service, professional, price and specialist information. Integration capabilities also remain here; service permissions have their own options.",
  "permissionsTitle": "Additional permissions",
  "permissionsHelp": "Choose whether the agent can query context, add notes and update contacts. Current-mode transfers are configured under Transfers.",
  "saved": "Configuration saved.",
  "synced": "Configuration saved and synchronized with Agents.",
  "syncPending": "Configuration saved, but synchronization with Agents was not confirmed. Review the state before using the agent.",
  "draftSaved": "Draft saved. The agent was not published.",
  "statusTitle": "Agent status",
  "statusReady": "Active and ready",
  "statusDraft": "Draft",
  "statusPending": "Needs review",
  "statusHelp": "This is the state of the last saved configuration. Changes on this screen take effect only when saved."
},
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        creationChoice: {
          title: "Who do you want to add?",
          help: "Choose an option to see only the settings you need.",
          humanTitle: "Team member",
          humanDescription: "Create access for service agents, managers, or team administrators.",
          aiTitle: "AI Agent",
          aiDescription: "Follow a simple flow to choose the industry, capabilities, and agent behavior.",
          humanSelected: "New team member",
          humanSelectedHelp: "Complete access and service details.",
          aiSelected: "New AI agent",
          aiSelectedHelp: "The guided assistant appears directly below the identification fields.",
          changeType: "Change type",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          userType: "User type",
          userTypeOptions: {
            human: "Human",
            aiAgent: "AI Agent",
          },
          language: "Language",
          profilePic: "User photo",
          ticketOrder: "Conversation ordering",
          ticketOrderOptions: {
            oldestFirst: "Oldest first",
            newestFirst: "Newest first",
          },
          whatsapp: "Default Connection",
        },
        sections: {
          userData: "User details",
          userDataHelp: "Set identification, user type, and general preferences.",
          attendance: "Service",
          attendanceHelp: "Configure the queues and default connection used by this user.",
        },
        humanWizard: {
          steps: { access: "Access", service: "Permissions", review: "Review" },
          accessTitle: "How will this person access Talk?",
          accessHelp: "Enter only the details needed to create access. Other settings can be changed later.",
          nameHelp: "Use the name your team uses to identify this person.",
          emailHelp: "This email will be used to sign in to Talk.",
          passwordHelp: "Create an initial password with at least 5 characters and share it through a secure channel.",
          togglePassword: "Show or hide password",
          serviceTitle: "What will this person be able to access?",
          serviceHelp: "Choose the permission level and route conversations. Queues and connection can be changed later.",
          roles: {
            agent: { title: "Service agent", help: "Handles conversations and uses features enabled by an administrator." },
            admin: { title: "Administrator", help: "Configures the company and manages users, connections, and all conversations." },
          },
          queuesTitle: "Service queues",
          queuesHelp: "Select the topics or teams this person can serve. You may continue without choosing a queue.",
          queuesLabel: "Select queues",
          noDefaultConnection: "No default connection",
          reviewTitle: "Review before creating access",
          reviewHelp: "Check the details below. The password is hidden for security.",
          review: {
            person: "Person", access: "Sign-in email", role: "Permission", service: "Service",
            queueCount: "{{count}} queue(s) selected", noQueues: "All or no specific queue",
          },
          preferencesTitle: "Optional preferences",
          preferencesHelp: "Interface language and conversation order already use recommended defaults.",
          afterCreateHelp: "Photo, access schedule, and other details can be configured later by editing the user.",
          create: "Create user",
        },
        aiAgent: {
          title: "AI agent profile",
          help: "Configure this agent user's main behavior. Synchronization with Flowch Agents is handled by the backend.",
          description: "Description",
          instructions: "Agent instructions",
          llmProvider: "LLM provider",
          llmModel: "LLM model",
          temperature: "Temperature",
          maxTokens: "Maximum token limit",
          mediaTitle: "Received files",
          mediaHelp: "Define which file types this agent can send to Flowch Agents. Talk does not save transcriptions; it only forwards the file when allowed.",
          allowAudioMessages: "Allow audio",
          allowImageMessages: "Allow images",
          allowDocumentMessages: "Allow documents",
          maxMediaFileSizeMb: "Maximum file size (MB)",
          responseDelaySeconds: "Wait for messages in seconds",
          proactiveDelayMinutes: "Active message after minutes without reply",
          maxProactiveMessages: "Maximum active messages before closing",
          proactivePrompt: "Active message prompt",
          unavailableMessage: "Message when AI is unavailable",
          unavailableMessageHelp: "Sent when Agents is unavailable or has insufficient credits. In operational mode, it is also used for an invalid response. Leave blank to use the default message. Proactive messages do not send this notice to the contact.",
          failureTitle: "Service failure contingency",
          failureHelp: "Talk does not automatically repeat a request to repair a failure. It sends this notice once and pauses AI on the ticket. To resume, the team must take over and then assign the ticket back to the agent after resolving the cause. The pause prevents proactive messages and inactivity closure.",
          failureTransfer: "Transfer to a queue on failure",
          failureQueue: "Contingency queue",
          failureQueueHelp: "Choose a queue that permits manual attendance and does not automatically assign tickets to AI. With transfer disabled, the ticket remains paused with an activity for team review. This also covers insufficient credits and invalid responses.",
          failureQueueSelect: "Select a human attendance queue",
          failureQueueUnavailable: "Saved queue unavailable for contingency",
          failureUnsupported: "The contingency configuration uses an unsupported version. Preserve the data and request a review.",
          proactiveClosureKeywords: "Phrases that close silently",
          proactiveClosureKeywordsHelp: "Compatibility field. Prefer using the silent closure prompt.",
          proactiveClosurePrompt: "Silent closure prompt",
          proactiveClosurePromptHelp: "Instruction sent to Flowch Agents to decide whether the contact's latest reply allows closing the conversation without sending another message. Ask for JSON only with shouldClose, confidence, and reason.",
          proactiveCloseSilently: "Close silently when the contact confirms it is resolved",
          allowDirectTicketClosure: "Allow the agent to close conversations directly",
          allowDirectTicketClosureHelp: "Disabled: the agent keeps serving the contact and only the configured proactive-message or inactivity flow may close the ticket.",
          operationalSkills: {
            title: "Operational tools",
            help: "Enable only the actions this agent actually needs. Fewer tools reduce unnecessary decisions and technical-sounding replies. Handoff is the recommended setting for new agents.",
            items: {
              talk_handoff: {
                label: "Transfer conversations",
                help: "Allows handoff to a queue, person, or another AI agent while preserving the conversation."
              },
              talk_query_context: {
                label: "Query operational context",
                help: "Provides queue and assignee lists. Enable only when the agent must research destinations before a handoff."
              },
              talk_add_internal_note: {
                label: "Add internal notes",
                help: "Allows the agent to add auditable internal records to the conversation."
              },
              talk_update_contact: {
                label: "Update contact data",
                help: "Allows name, email, or phone number changes during the conversation."
              }
            }
          },
          loopHandoffQueue: "Queue for AI loop handoff",
          smartHandoff: "Smart handoffs",
          smartHandoffHelp: "Lets the agent understand natural requests, check available people and queues, and transfer only after Flowch Talk validation. Enabled by default.",
          loopHandoffQueueNone: "Use the current queue handoff queue",
          dissatisfactionEscalation: "Escalate dissatisfied contacts",
          dissatisfactionEscalationQueue: "Queue responsible for service recovery",
          dissatisfactionEscalationQueueNone: "Select the responsible queue",
          dissatisfactionEscalationHelp: "The agent makes one recovery attempt. If dissatisfaction continues or the contact asks for a manager or responsible person, it transfers to this queue without repeating questions.",
          signMessages: "Send signature in agent messages",
          capabilitiesTitle: "Service capabilities",
          capabilitiesHelp: "Use capabilities to guide specialist sub-agents without creating more Talk users.",
          addCapability: "Add capability",
          removeCapability: "Remove capability",
          capabilityName: "Capability name",
          capabilityType: "Capability type",
          capabilityDescription: "Short description",
          capabilityInstructions: "Capability instructions",
          capabilityEnabled: "Enabled",
          wizard: {
            loading: "Loading agent templates...",
            title: "Guided agent creation",
            help: "Choose an industry, enable capabilities, and provide only the required information. Talk builds the technical instructions for you.",
            advancedMode: "Technical setup",
            guidedMode: "Return to guided creation",
            modeDraftPreserved: "The other mode's configuration was preserved and can be restored.",
            modeSwitchToGuidedConfirm: "Guided creation will replace the technical configuration when you save. Continue?",
            steps: { objective: "Goal", knowledge: "Knowledge", capabilities: "Capabilities", behavior: "Behavior", review: "Review" },
            objectiveTitle: "Give the agent an identity and choose its industry",
            objectiveHelp: "Talk will use these choices to prepare a safe foundation for this type of service.",
            agentName: "Agent name",
            agentNameHelp: "Use a short, recognizable name, such as Nair or Clinic Assistant.",
            segmentTitle: "What industry will this agent serve?",
            segmentHelp: "The template provides a safe foundation that you can personalize in the next steps.",
            templates: {
              medicalClinic: "Clinics and healthcare",
              medicalClinicDescription: "Administrative service, questions, professionals, and appointments.",
              technologyCompany: "Technology and SaaS",
              technologyCompanyDescription: "Product, opportunities, demos, and support triage.",
              otherBusiness: "Other industry",
              otherBusinessDescription: "A flexible template for services, retail, and other businesses.",
            },
            capabilitiesTitle: "What can the agent do?",
            capabilitiesHelp: "Enable only what your company can support with current information and integrations.",
            advancedBadge: "Advanced",
            recommendedBadge: "Recommended",
            integrationBadge: "May require integration",
            capabilities: {
              faq: "FAQ and common questions",
              faqDescription: "Answers questions using registered information.",
              scheduling: "Scheduling",
              schedulingDescription: "Guides or schedules through configured links and integrations.",
              appointmentManagement: "Appointment confirmation and changes",
              appointmentManagementDescription: "Confirms, changes, or cancels through an authorized flow.",
              professionalsSpecialties: "Professionals and specialties",
              professionalsSpecialtiesDescription: "Shares professionals, specialties, locations, and services.",
              coveragePrices: "Insurance and prices",
              coveragePricesDescription: "Shares registered coverage, private care, and prices.",
              advancedOperations: "Advanced operations",
              advancedOperationsDescription: "Performs authorized actions in connected systems.",
              technologyFaqDescription: "Answers product questions from approved documentation.",
              leadQualification: "Lead qualification",
              leadQualificationDescription: "Understands needs, context, timing, and contact details.",
              demoScheduling: "Demo scheduling",
              demoSchedulingDescription: "Schedules demos through the configured flow.",
              supportTriage: "Support triage",
              supportTriageDescription: "Collects context and routes to the appropriate queue.",
              advancedIntegrations: "Advanced integrations",
              advancedIntegrationsDescription: "Runs configured operations with safe confirmation.",
              customerIntake: "Customer intake",
              customerIntakeDescription: "Asks brief questions for correct routing.",
              generalSchedulingDescription: "Schedules services through the configured link or integration.",
            },
            businessTitle: "Teach the essentials about your business",
            businessHelp: "This becomes the agent's approved information source. Do not include passwords, tokens, or secrets.",
            moreKnowledgeTitle: "Add useful information",
            moreKnowledgeHelp: "Hours, address, scheduling link, and specific rules are optional.",
            fields: {
              organizationName: "Company or location name",
              businessHours: "Business hours",
              summary: "How would you explain the business to a new team member?",
              summaryHelp: "Explain the audience, goal, and service boundaries.",
              services: "Available services, specialties, products, or information",
              address: "Addresses and locations",
              schedulingUrl: "Authorized scheduling link",
              schedulingUrlHelp: "When empty, the agent will not automatically confirm bookings.",
              schedulingUrlRequiredHelp: "Required for scheduling capabilities. Use a complete link starting with http:// or https://.",
              advancedOperations: "Which advanced operations are authorized?",
              advancedOperationsRequiredHelp: "Describe exactly what may be performed and which confirmations are required.",
              noHandoffQueue: "Use the current queue's handoff queue",
              additionalRules: "Additional rules",
              additionalRulesHelp: "Enter real business policies. Mandatory safety rules remain active.",
            },
            behaviorTitle: "Define how the agent should operate",
            behaviorHelp: "Technical model names, temperature, and token limits are managed by Talk.",
            optionalBehaviorTitle: "Optional response and autonomy settings",
            optionalBehaviorHelp: "Recommended defaults are already selected. Change them only when your operation requires it.",
            routingTitle: "Where will the agent serve?",
            routingHelp: "Choose at least one queue and the connection that will receive conversations. This prevents publishing an agent with no service entry point.",
            queuesLabel: "Queues served by the agent",
            selectConnection: "Select a connection",
            routingRequired: "Resolve the highlighted items: capability, queue, connection, and any required link or operation rules.",
            behavior: {
              intelligenceProfile: {
                title: "Intelligence", help: "Balance speed, cost, and depth.",
                essential: "Essential — fast and economical", balanced: "Balanced — recommended", advanced: "Deep — complex cases",
              },
              tone: {
                title: "Tone", help: "How the agent should speak with customers.",
                welcoming: "Welcoming", professional: "Professional", casual: "Friendly and natural", technical: "Technical",
              },
              responseLength: {
                title: "Answer length", help: "Depth stays the same; only presentation changes.",
                short: "Short", balanced: "Balanced", detailed: "Detailed",
              },
              autonomyLevel: {
                title: "Autonomy", help: "Control whether the agent only guides or also performs actions.",
                answer_only: "Answers only", suggest_actions: "Suggests actions", confirm_actions: "Acts after confirmation", automatic: "Automatic for authorized actions",
              },
            },
            reviewTitle: "Protections included in this configuration",
            review: {
              agent: "Agent",
              segment: "Industry",
              capabilities: "Active capabilities",
              queues: "Queues",
              connection: "Default connection",
              behavior: "Behavior",
              usage: "Estimated usage",
              safePrompt: "Mandatory industry rules are added automatically.",
              humanHandoff: "Out-of-scope requests offer a human handoff.",
              onlyEnabled: "Only enabled capabilities are added to the agent instructions.",
              versionedTemplate: "The template and version are recorded for future updates.",
            },
            readyToPublish: "Configuration reviewed",
            finalReviewTitle: "Ready to publish?",
            finalReviewHelp: "Talk checked every required item. Return to a step if you want to adjust anything.",
            readiness: {
              name: "Agent name", template: "Industry template", organization: "Organization information",
              capabilities: "Enabled capabilities", connection: "Default connection", queues: "Service queue",
              scheduling: "Scheduling link", operations: "Advanced operation rules", autonomy: "Autonomy limits",
              ready: "Configured", missing: "Needs attention",
            },
            usage: {
              title: "Usage estimate",
              summary: "Up to {{tokens}} tokens per answer · {{cost}} relative usage",
              help: "This is a limit and usage reference. Actual cost depends on the provider, contract, and context volume.",
              cost: { low: "low", medium: "medium", high: "high" },
            },
            simulator: {
              title: "Simulate before publishing",
              help: "Test one question in an isolated conversation. The simulator creates no ticket, uses no real contact, and sends nothing to WhatsApp.",
              message: "Test message",
              placeholder: "Example: Do you accept my health insurance?",
              run: "Simulate answer",
              running: "Simulating...",
              saveFirst: "Save as draft and reopen the agent to enable simulation.",
              operationsNote: "The preview validates knowledge, tone, and boundaries. Test transfers and other operations later in a controlled channel.",
            },
            testTitle: "Recommended validation after publishing",
            testHelp: "After creation, send these messages through a test channel before routing real customers:",
            test: {
              knownQuestion: "A common question covered by the registered information.",
              unknownQuestion: "An out-of-scope question to confirm the agent does not invent an answer.",
              humanRequest: "A request for human service to validate the handoff.",
            },
            back: "Back",
            next: "Continue",
            finishReview: "Complete review",
            saveDraft: "Save draft",
            draftSaved: "Agent draft saved successfully.",
            publish: "Publish agent",
          },
        },
        accessSchedule: {
          title: "Access hours",
          help: "Control when this user can access the system or when this AI agent can reply. Messages are still received normally and wait for the next allowed window.",
          enabled: "Enable access hours",
          profile: "Schedule profile",
          customProfile: "Custom configuration",
          saveAsProfileName: "Save this configuration as a profile",
          saveAsProfileNameHelp: "Optional. Use it to reuse the same schedule for other users.",
          timezone: "Timezone",
          daysOfWeek: "Allowed days",
          startTime: "Start",
          endTime: "End",
          warnBeforeMinutes: "Warn how many minutes before the end",
          forceLogoutHumans: "Force logout for human users outside hours",
          pauseAiOutsideHours: "Pause AI agents outside hours",
          blockHumanActionsOutsideHours: "Block human actions outside hours",
          temporaryOverrideTitle: "Temporary override",
          temporaryOverrideHelp: "Use this when an admin needs to grant extra time without changing the default schedule.",
          temporaryOverrideUntil: "Allow access until",
          temporaryOverrideReason: "Override reason",
          warningToast: "In {{minutes}} min. you will be logged out because your work period is close to ending.",
          forceLogoutToast: "Your allowed access time has ended. You were logged out automatically.",
          weekdays: {
            sun: "Sunday",
            mon: "Monday",
            tue: "Tuesday",
            wed: "Wednesday",
            thu: "Thursday",
            fri: "Friday",
            sat: "Saturday"
          }
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          saving: "Saving...",
          cancel: "Cancel",
        },
        validation: {
          required: "Required field",
          tooShort: "Enter at least 2 characters",
          tooLong: "The entered value is too long",
          passwordMinimum: "The password must have at least 5 characters",
          invalidEmail: "Enter a valid email",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a conversation to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New Chat",
        },
      },
      ticketsUserSelect: {
        placeholder: "Agents",
        all: "All",
        unassigned: "Unassigned",
        only: "Only",
        onlyTooltip: "Filter only this item",
        allTooltip: "Show all",
        selectAllTooltip: "Select all",
        clearAllTooltip: "Deselect all",
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
        all: "All",
        noQueue: "No queue",
        only: "Only",
        onlyTooltip: "Filter only this item",
        allTooltip: "Show all",
        selectAllTooltip: "Select all",
        clearAllTooltip: "Deselect all",
      },
      tickets: {
        toasts: {
          deleted: "The conversation you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search conversations and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Conversation",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        noQueueUsers: "No agents found in this queue",
        queueUsersLabel: "Agents available in the destination queue",
        loadingQueueUsers: "Loading queue agents...",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No conversations found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        closedTag: "Resolved",
        groupTag: "Group",
        buttons: {
          accept: "Accept",
        },
      },
      groupParticipantsModal: {
        title: "Group participants",
        ticketTitle: "Conversation participants",
        openButton: "Manage participants",
        description:
          "Choose which internal users can follow this group in Flowch Talk. This does not change the real WhatsApp group members; it only controls who follows and interacts here.",
        ticketDescription:
          "Choose which internal users can follow and interact in this conversation without changing the main assignee.",
        userLabel: "User",
        userPlaceholder: "Select a user",
        empty: "No internal participant has been added yet.",
        roles: {
          admin: "Admin",
          member: "Participant",
          viewer: "Viewer",
        },
        buttons: {
          add: "Add",
          remove: "Remove participant",
          close: "Close",
        },
        toasts: {
          added: "Participant added.",
          removed: "Participant removed.",
        },
      },
      newTicketModal: {
        title: "Create Conversation",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        queueLabel: "Queue",
        queuePlaceholder: "Select a queue",
        userLabel: "Agent",
        userPlaceholder: "Select an agent",
        loadingUsers: "Loading agents...",
        connectionLabel: "Connection",
        connectionPlaceholder: "Select a connection",
        loadingConnections: "Loading connections...",
        noConnections: "No active connection available",
        noQueueUsers: "No queue available for your user",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Conversations",
          indicators: "Indicators",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        connectionWarning: "A QR Code connection needs attention.",
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          id: "ID",
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          aiAgents: "AI agents",
          actions: "Actions",
        },
        aiAgents: {
          enabled: "Allowed",
          disabled: "Blocked",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Conversations in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          id: "ID",
          name: "Name",
          email: "Email",
          profile: "Profile",
          type: "Type",
          whatsapp: "Default Connection",
          status: "Status",
          actions: "Actions",
        },
        userTypes: {
          human: "Human",
          ai_agent: "AI Agent",
        },
        status: {
          online: "Online",
          offline: "Offline",
        },
        aiStatus: {
          ready: "Ready",
          draft: "Draft",
          pending_config: "Configure",
          pending_sync: "Syncing",
          error: "Error",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open conversations will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        apiDocs: {
          copied: "Copied to clipboard!",
          intro: "Define global attendance rules and check the data used by external integrations. Use the token carefully and prefer connectionId in new integrations.",
          generalTitle: "General settings",
          generalDescription: "Behavior controls used across the operation.",
          apiTitle: "API integrations",
          apiDescription: "Token, endpoints, and examples for external systems to send messages and manage conversations.",
          tokenTitle: "API Token",
          tokenHelp: "Use this token in the authorization header. Avoid sharing it in screenshots, URLs, or public messages.",
          copyToken: "Copy Token",
          quickDocTitle: "Quick API documentation",
          overview: "Overview",
          overviewToken: "Use the token above in the Authorization: Bearer YOUR_TOKEN header.",
          overviewNumber: "The number accepts spaces, parentheses, hyphens, and a + prefix. For Brazilian numbers supplied with an area code only, country code 55 is added automatically. Normalized example: 5519978175005.",
          overviewConnection: "Send connectionId in new integrations to choose the correct connection.",
          overviewTransfer: "If you want a more explicit endpoint for transfers, use /transfer.",
          overviewResolve: "To close an open conversation using the contact number, use /resolve.",
          requiredHeaders: "Required headers",
          sendMessage: "1. Send message",
          sendDescription: "Use this endpoint to send a message and, in the same request, route the conversation to a specific queue and assignee.",
          transferQueue: "2. Change queue",
          transferDescription: "Use this endpoint to transfer the conversation to a queue and optionally assign it to a user in that queue. A message can also be sent with the transfer.",
          sendTemplate: "3. Send an Official WhatsApp template",
          templateDescription: "Use this endpoint to start or resume an Official WhatsApp conversation with a Meta-approved template. You can also set the responsible queue and assignee.",
          templateConnectionIdHint: "For Official WhatsApp, use the ID shown on the Connections screen. The selected queue must belong to the same customer as the connection.",
          templateConnectionRequired: "required; accepts the ID shown on the Connections screen for an Official WhatsApp connection",
          templateNameRequired: "exact name of the template approved by Meta",
          templateLanguage: "approved language code, for example pt_BR",
          templateParameters: "object mapping values by name for named templates, such as nome and data; older positional templates still accept a list in variable order",
          resolveConversation: "4. Resolve conversation",
          resolveDescription: "Closes the contact's most recently updated open conversation. It follows the same rules as manual resolution in Flowch Talk.",
          resolveNumberRequired: "the only required field; accepts formatted input and automatically adds 55 to Brazilian numbers with an area code",
          resolveBehavior: "On resolution, the system sends the queue closing message, records the history, updates the interface in real time, and runs conversation-finished integrations. A legacy connection farewell is also sent when configured.",
          resolveSuccess: "Successful response:",
          resolveValidation: "Recommended validation: confirm the closed status in the response and verify that the conversation left the Working/Queue lists. If the queue has a closing message, also confirm that it was recorded in the conversation.",
          resolveAlreadyClosed: "If the most recent conversation for this number is already closed, the API returns 409 with ERR_API_TICKET_ALREADY_CLOSED. Use this response to treat the request as duplicated or already processed.",
          resolveMethod: "This endpoint only accepts POST. GET requests return 405 with ERR_API_RESOLVE_METHOD_NOT_ALLOWED.",
          recommendedNew: "recommended for new integrations",
          required: "required",
          requiredWithoutMedia: "required when there is no media",
          optionalQueue: "optional, but recommended when you already want to route the attendance",
          optionalUser: "optional; ID of the user who will be responsible for the conversation",
          userAssignmentValidation: "When userId is provided, the API verifies that the user belongs to the same company, is assigned to the resolved queue and, for an AI agent, that the queue allows AI and the agent is ready. If queueId is omitted, the queue already resolved on the conversation or connection is used.",
          aiContextHandoff: "When assigned to a ready AI agent, Talk imports recent context when creating the Agents conversation. Later API sends enter incremental context on the next interaction. Under V2, confirmed sends start the configured follow-up and inactivity timers; transfer without a message starts no timer. Outside the WhatsApp Official free-response window, follow-up is skipped and inactivity closure has no farewell. Check the message, assignee and ticket status.",
          successResponse: "Success response example:",
          optionalLegacy: "optional, kept only for legacy integrations",
          optional: "optional",
          javascriptExample: "JavaScript example",
          expectedResponses: "Expected responses",
          response200: "operation completed successfully",
          response400: "invalid number, queueId, userId, connectionId, or body; also returned when the user does not belong to the queue",
          response409: "the operation requires another action or the selected AI agent is not ready",
          response401: "missing or invalid token",
          response404: "queue, connection, or open conversation not found",
          response503: "connection without an active session",
        },
        aiAgents: {
          title: "Flowch Agents",
          description: "API key and endpoint used by this customer's AI agents.",
          help: "Configure the tenant key from Flowch Agents. It is encrypted in the backend, shown masked after saving, and never sent to the frontend in plain text.",
          apiUrl: "API URL",
          apiUrlHelp: "Use the official default unless the customer runs on a dedicated environment.",
          apiKey: "API key",
          apiKeyHelp: "Paste a new key to replace the current one. If it appears masked, it is already configured.",
          companyWebsite: "Customer website",
          companyWebsiteHelp: "Optional. If Flowch Agents is unavailable, this address will be shown to the contact as an alternative for booking appointments. If left empty, the message will mention phone support only.",
          companyWebsitePlaceholder: "https://www.example.com",
          save: "Save Flowch Agents",
          internalSkillsTitle: "Talk internal skills",
          internalSkillsDescription: "These routes are private and called by Flowch Agents to run controlled actions in a conversation. The signing secret is created by the backend and is not shown on screen.",
          skillQueryContext: "talk_query_context: reads safe context from the current conversation.",
          skillRequestHuman: "talk_request_human: requests human attendance and can move to the handoff queue.",
          skillTransferQueue: "talk_transfer_queue: transfers to another queue that allows AI agents.",
          skillCloseAttendance: "talk_close_attendance: closes the conversation using Talk rules.",
          skillAddNote: "talk_add_internal_note: records an auditable internal note.",
          skillUpdateContact: "talk_update_contact: updates the contact name, email, or number.",
          internalSkillsValidation: "Every call validates signature, company, ticket, assigned AI user, and queue AI permission before running any action.",
        },
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          allowSignMessageChoice: {
            name: "Allow user to choose message signature",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        previousAttendance: {
          load: "Load previous conversation",
          loading: "Loading previous conversation...",
          none: "There is no previous conversation for this contact.",
          title: "Previous conversation",
          whatsappHistoryLoad: "Fetch earlier WhatsApp history",
          whatsappHistoryLoading: "Fetching WhatsApp history...",
          whatsappHistoryImported: "{{count}} messages synced.",
          whatsappHistoryEmpty: "No new older messages found in this block.",
        },
        internalEvents: {
          show: "Internal events",
          hide: "Hide internal events",
          loading: "Loading internal events...",
          empty: "There are no internal events for this conversation.",
          systemAuthor: "System",
          types: {
            message_received: "Message received",
            message_sent: "Message sent",
            conversation_created: "Conversation created",
            conversation_reopened: "Conversation reopened",
            conversation_opened: "Conversation opened",
            ai_operational_failure: "AI attendance interrupted by a failure; team review required",
            ai_operational_action_blocked: "AI action not executed under the service rules; the conversation remains available.",
            ai_operational_pending: "AI operation requires team review. Check the conversation and take ownership of the next step before repeating an action.",
            ai_operational_close_resolved: "Conversation closed by validated resolution.",
            ai_operational_close_inactivity: "Conversation closed at the configured inactivity deadline.",
            ai_operational_transfer: "Validated transfer recorded.",
            ai_operational_reply: "AI reply recorded; confirm delivery in the conversation.",
            ai_operational_clarify: "Clarification recorded; check the offer and the contact reply.",
            ai_operational_no_reply: "AI chose not to reply; this does not mean resolution.",
            ai_operational_clock_cancelled: "Automatic waiting for an external send was cancelled. Follow-up starts after an actual AI interaction.",
            ai_operational_continuation_cancelled: "Previous continuation cancelled after a context change.",
            conversation_closed: "Conversation closed",
            conversation_status_changed: "Status changed",
            assignment_changed: "Assignee changed",
            queue_changed: "Queue changed",
            ai_proactive_message_sent: "AI proactive message",
            ai_proactive_attendance_closed: "Conversation closed by AI",
            ai_skill_human_requested: "AI requested human support",
            ai_skill_attendance_closed: "AI closed the conversation",
            ai_skill_queue_transferred: "AI transferred to queue",
            ai_skill_user_transferred: "AI transferred to assignee",
            ai_skill_internal_note_added: "AI internal note",
            internal_note_added: "Internal note",
          },
        },
        mediaUnavailable: {
          default: "Media unavailable.",
          image: "Image unavailable.",
          audio: "Audio unavailable.",
          video: "Video unavailable.",
          document: "Document unavailable.",
          sticker: "Sticker unavailable.",
        },
        internalNote: {
          open: "Internal note",
          title: "Add internal note",
          mentionsLabel: "Mention users",
          mentionsPlaceholder: "Select users to mention with @",
          noteLabel: "Internal note",
          notePlaceholder: "Write an internal note. Users mentioned with @ will be added as conversation participants.",
          cancel: "Cancel",
          save: "Save note",
          saving: "Saving...",
          toasts: {
            saved: "Internal note saved.",
          },
        },
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            returnToPending: "Move back to Queue",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this conversation to send a message.",
        signMessage: "Sign",
        internalNote: {
          toggle: "Internal message",
          activeHint:
            "Internal note mode is active. This message will only be visible to the team and will not be sent to the contact.",
          placeholder:
            "Write an internal note. Use @Name to mention and add users as participants.",
          mentionAll: "All",
          mentionAllHint: "Notify all participants and available users",
          mentionUserHint: "Talk user",
        },
        templateChooser: {
          title: "Choose an approved template",
          description:
            "This contact is outside the 24-hour window. Select a template to continue.",
          metaRules:
            "Meta rules (Official API): outside 24 hours only approved templates are allowed; avoid repeating the same template for the same conversation and prioritize contextual content to reduce blocks.",
          selectLabel: "Template",
          parameterLabel: "Value for {{variable}}",
          parametersRequired: "Fill in every template variable before sending.",
          previewLabel: "Template message",
          cancel: "Cancel",
          send: "Send template",
          sending: "Sending...",
        },
      },
      messageInput: {
        audio: {
          errors: {
            permissionDenied: "Allow microphone access in your browser to record audio.",
            deviceNotFound: "No microphone was found on this device.",
            deviceUnavailable: "The microphone is busy or unavailable. Close other applications that may be using it and try again.",
            notSupported: "This browser does not support audio recording. Update the browser or use another device.",
            emptyAudio: "No audio was captured. Record again and wait a moment before sending.",
            recordingFailed: "The audio could not be recorded. Check the microphone and try again.",
          },
        },
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        copyLink: "Copy activity link",
        copyLinkSuccess: "Activity link copied.",
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete conversation #",
          titleFrom: "from contact ",
          message: "Attention! All conversation-related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        resend: "Resend",
        resending: "Resending...",
        resendSuccess: "Message resent. Wait for WhatsApp confirmation.",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_AI_OPERATIONAL_PROMPT_TOO_LONG: "The instructions and operating contract exceed the Agents limit. Shorten the editable prompt while preserving important facts and try again.",
        ERR_AI_OPERATIONAL_POLICY_INVALID: "Review the policy: select valid destinations and positive whole-minute deadlines for enabled options.",
        ERR_AI_OPERATIONAL_POLICY_CONFLICT: "Someone else changed this configuration. Reopen the form, review the current version and save again.",
        ERR_AI_OPERATIONAL_DESTINATION_INVALID: "A selected destination is unavailable in this company or queue. Reopen the form and review your selection.",
        ERR_AI_OPERATIONAL_SKILL_DISABLED: "This tool cannot execute operations in the new mode. Transfer and closure require a decision validated by Talk.",
        ERR_CONNECTION_OUTBOUND_QUEUE_INVALID: "One of the authorized queues does not belong to this organization.",
        ERR_NO_CONNECTION_FOUND: "The corresponding connection was not found.",
        ERR_NETWORK_UNAVAILABLE:
          "The connection to the server was interrupted. Please wait a moment and try again.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_OFFICIAL_SESSION_NOT_ALLOWED:
          "This session action is available only for QR Code connections.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_CONTACT_INVALID_NUMBER:
          "Enter a valid phone number with country and area codes. +55 is added automatically for Brazilian numbers.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_WAPP_EMPTY_PROVIDER_RESPONSE:
          "WhatsApp Web did not confirm the message send. Restart the QR Code connection and try again.",
        ERR_WAPP_MESSAGE_NOT_ACKNOWLEDGED:
          "WhatsApp did not acknowledge this message. The QR Code connection will be checked automatically.",
        ERR_MESSAGE_NOT_FOUND: "Message not found.",
        ERR_MESSAGE_RESEND_NOT_SUPPORTED:
          "Resend is available only for text messages on WhatsApp QR Code connections.",
        ERR_MESSAGE_RESEND_MEDIA_NOT_SUPPORTED:
          "Media resend is not available yet. Send the file again.",
        ERR_MESSAGE_RESEND_NOT_ALLOWED:
          "This message cannot be resent. It was already confirmed, deleted, or resent.",
        ERR_HISTORY_SYNC_NOT_SUPPORTED:
          "Earlier history fetch is available only for WhatsApp QR Code connections.",
        ERR_HISTORY_SYNC_NO_WHATSAPP:
          "There is no WhatsApp QR Code connection linked to this conversation.",
        ERR_HISTORY_SYNC_FETCH_FAILED:
          "Could not fetch history from WhatsApp Web. Restart the QR Code connection and try again.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_OFFICIAL_PHONE_NOT_REGISTERED:
          "The configured official number is not registered on the WhatsApp Business Platform Cloud API. Verify the number registration in Meta.",
        ERR_OFFICIAL_MESSAGE_BLOCKED_BY_META:
          "Meta blocked this send to maintain healthy ecosystem engagement. Try again later or review the content/template.",
        ERR_OFFICIAL_ACCESS_DENIED:
          "Meta denied this send because of the official number token or permissions. Reauthorize the connection or check permissions in Meta.",
        ERR_META_TRANSIENT_SEND_ERROR:
          "Meta returned a temporary send error. Try again in a few moments.",
        ERR_OFFICIAL_TEMPLATE_REQUIRED_OUTSIDE_24H:
          "This message cannot be sent as free text because the 24-hour window is closed. Send an approved Meta template to reopen the conversation.",
        ERR_API_CONNECTION_REQUIRED:
          "Provide the connection that must be used by this integration.",
        ERR_API_OFFICIAL_TEMPLATE_CONNECTION_REQUIRED:
          "Template sending requires an Official WhatsApp connection.",
        ERR_API_OPEN_TICKET_NOT_FOUND:
          "No open conversation was found for this number.",
        ERR_API_RESOLVE_INVALID_NUMBER:
          "Provide a valid number to resolve the conversation.",
        ERR_API_TICKET_ALREADY_CLOSED:
          "This conversation was already closed.",
        ERR_TICKET_ALREADY_CLOSED:
          "This conversation was already closed.",
        ERR_API_RESOLVE_METHOD_NOT_ALLOWED:
          "Use POST to resolve a conversation through the API.",
        ERR_OFFICIAL_TEMPLATE_NOT_ALLOWED_FOR_QUEUE:
          "The selected template is not allowed for this queue.",
        ERR_OFFICIAL_TEMPLATE_ALREADY_SENT:
          "This same template has already been sent in this conversation. Please choose a different approved template.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_INVALID: "Choose a valid template variable format.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_MIXED: "Do not mix named and positional variables in the same template.",
        ERR_META_TEMPLATE_PARAMETER_NAME_INVALID: "Use lowercase variable names without spaces or accents, such as customer_name.",
        ERR_META_TEMPLATE_POSITIONAL_SEQUENCE_INVALID: "Positional variables must start at position 1 and continue without gaps.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_MISMATCH: "The text variables do not match the selected format.",
        ERR_META_TEMPLATE_PARAMETER_FORMAT_WITHOUT_VARIABLES: "Remove the variable format or add at least one variable to the text.",
        ERR_META_TEMPLATE_PARAMETER_EXAMPLE_REQUIRED: "Provide an example for every template variable.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open conversation for this contact.",
        ERR_OTHER_OPEN_TICKET_WITH_USER_QUEUE:
          "Conversation {{ticket}} is already open for this contact with {{user}}, in queue {{queue}}. Ask that user to transfer it to you.",
        ERR_OTHER_OPEN_TICKET_WITH_USER:
          "Conversation {{ticket}} is already open for this contact with {{user}}. Ask that user to transfer it to you.",
        ERR_OTHER_OPEN_TICKET_WITH_QUEUE:
          "Conversation {{ticket}} is already open for this contact in queue {{queue}}, waiting for service.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_ACCESS_SCHEDULE_OUTSIDE_HOURS:
          "Your allowed access time has ended. Contact an administrator if you need a temporary override.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_TRANSFER_QUEUE_NOT_ALLOWED: "You can only transfer conversations within queues you belong to.",
        ERR_TRANSFER_USER_NOT_IN_QUEUE: "The selected assignee does not belong to the destination queue.",
        ERR_AI_AGENT_NOT_READY: "The selected AI agent is not active and ready to handle conversations yet.",
        ERR_AI_AGENT_TEMPLATE_NOT_FOUND: "The selected agent template no longer exists. Choose another template.",
        ERR_AI_AGENT_INTELLIGENCE_PROFILE: "Choose a valid intelligence level.",
        ERR_AI_AGENT_COMMUNICATION_PROFILE: "Choose valid tone and answer-length options.",
        ERR_AI_AGENT_AUTONOMY_PROFILE: "Choose a valid autonomy level.",
        ERR_AI_AGENT_CAPABILITY_NOT_FOUND: "One selected capability does not belong to this template.",
        ERR_AI_AGENT_CAPABILITY_REQUIRED: "Enable at least one capability before publishing.",
        ERR_AI_AGENT_ORGANIZATION_REQUIRED: "Enter the company or location name before publishing.",
        ERR_AI_AGENT_SIMULATION_MESSAGE_REQUIRED: "Enter a test message between 2 and 1,500 characters.",
        ERR_AI_AGENT_SIMULATION_NOT_READY: "Save a complete agent draft before using the simulator.",
        ERR_AI_AGENT_SIMULATION_EMPTY_RESPONSE: "The simulator did not receive a valid answer. Try again in a moment.",
        ERR_AI_DISSATISFACTION_QUEUE_REQUIRED: "Select the responsible queue before enabling dissatisfied-contact escalation.",
        ERR_AI_DISSATISFACTION_QUEUE_INVALID: "The selected responsible queue is not available in this company.",
        ERR_AI_INTERNAL_SKILLS_INVALID: "Select only valid operational tools for the agent.",
        ERR_REQUEST_BODY_TOO_LARGE: "The submitted data is too large. Shorten long text fields or send files using the attachment field.",
        ERR_COMPANY_NOT_FOUND: "Organization not found.",
        ERR_ORGANIZATION_LOGO_INVALID: "Use a PNG, JPG, or WebP logo up to 2 MB.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No conversation found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_WHATSAPP_COEXISTENCE_DISABLED: "New coexistence connections are temporarily disabled in this environment.",
        ERR_WHATSAPP_COEXISTENCE_CONFIG_REQUIRED: "The Embedded Signup configuration for coexistence has not been completed in Meta yet.",
        ERR_WHATSAPP_COEXISTENCE_NOT_ACTIVE: "Meta did not confirm coexistence for this number. Make sure it remains active in the WhatsApp Business app and complete the dedicated coexistence flow.",
        ERR_META_APPLICATION_NOT_FOUND: "The Meta app does not exist or does not belong to your company.",
        ERR_META_APPLICATION_INACTIVE: "The selected Meta app is inactive.",
        ERR_META_APPLICATION_IN_USE: "This Meta app is linked to a connection and cannot be deleted.",
        ERR_META_APPLICATION_REQUIRED_FIELDS: "Enter name, App ID, and App Secret.",
        ERR_META_OAUTH_STATE_INVALID: "The Meta authorization expired or does not belong to this connection. Start the process again.",
        ERR_META_OAUTH_STATE_SECRET_NOT_CONFIGURED: "Secure Meta login signing is not configured on the server.",
        ERR_USER_REQUIRED: "An assigned agent is required.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating conversation on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_QUEUE_MANUAL_ATTENDANCE_DISABLED:
          "This queue does not allow manual attendance. Transfer the conversation to another queue before accepting.",
        ERR_QUEUE_AI_AGENTS_DISABLED:
          "This queue does not allow AI agents. Enable the queue permission before assigning this conversation.",
        ERR_FLOWCH_AGENTS_API_KEY_NOT_CONFIGURED:
          "The Flowch Agents API key is not configured in the backend.",
        ERR_FLOWCH_AGENTS_API_REQUEST_FAILED:
          "The Flowch Agents API returned an error. Check the configuration and try again.",
        ERR_FLOWCH_AGENTS_TENANT_MISMATCH:
          "This key belongs to another Flowch Agents tenant and does not contain this company's linked agents. Use a rotated key from the same tenant or unlink the agents before migrating.",
        ERR_FLOWCH_AGENTS_API_INVALID_RESPONSE:
          "The Flowch Agents API returned an invalid response.",
        ERR_AI_SKILL_SIGNATURE_REQUIRED:
          "The internal skill call requires a signature.",
        ERR_AI_SKILL_NAMESPACE_INVALID: "The tool namespace must start with a lowercase letter and contain up to 32 lowercase letters, numbers or underscores.",
        ERR_AI_SKILL_INVALID_SIGNATURE:
          "The internal skill signature is invalid.",
        ERR_AI_SKILL_NOT_SUPPORTED:
          "This internal skill is not supported by Talk.",
        ERR_AI_FAILURE_POLICY_INVALID: "Review the contingency settings: select a valid queue when enabling transfer.",
        ERR_AI_FAILURE_OPERATIONAL_REQUIRED: "Failure transfer requires the agent's operational mode.",
        ERR_AI_FAILURE_QUEUE_INVALID: "The contingency queue must belong to your company, permit manual attendance and not automatically assign to AI.",
        ERR_AI_INTERNAL_SKILL_DISABLED:
          "This operational tool is disabled for the agent assigned to the conversation.",
        ERR_AI_SKILL_TICKET_REQUIRED:
          "Provide the conversation before running the internal skill.",
        ERR_AI_SKILL_TICKET_NOT_ASSIGNED_TO_AI:
          "This conversation is not assigned to an AI agent.",
        ERR_AI_SKILL_NOTE_REQUIRED:
          "Provide the internal note to be recorded.",
        ERR_INTERNAL_NOTE_REQUIRED:
          "Provide the internal note to be recorded.",
        ERR_TICKET_PARTICIPANT_NOT_FOUND:
          "Conversation participant not found.",
        ERR_AI_SKILL_CONTACT_FIELDS_REQUIRED:
          "Provide at least one contact field to update.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
